(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const html = document.querySelector('html');

    ///// Mobile Nav Menu
    const toggleTrigger = document.querySelectorAll('[mobile-menu-toggle]');
    const mobileMenu = document.getElementById('mobile-menu');
    const navIcon = document.getElementById('nav-burger-icon');
    const layoutHeader = document.getElementById('shopify-section-layout-header');
    toggleTrigger.forEach((elem) => {
      elem.addEventListener('click', () => {
        // toggle nav icon class list
        navIcon.classList.toggle('open');
        // toggle html overflow classes
        html.classList.toggle('overflow-y-scroll');
        html.classList.toggle('overflow-hidden');
        // toggle mobile menu
        if (mobileMenu.style.display == 'block') {
          mobileMenu.style.display = '';
          layoutHeader.style.removeProperty('position');
          layoutHeader.style.removeProperty('top');
          layoutHeader.style.removeProperty('left');
        } else {
          mobileMenu.style.display = 'block';
          layoutHeader.style.position = 'fixed';
          layoutHeader.style.top = 0;
          layoutHeader.style.left = 0;
          layoutHeader.style.width = '100%';
        }
        html.classList.remove('scrolled');
      });
    });

    document.addEventListener('scroll', (e) => {
      let scrollPosition = window.scrollY;
      scrollPosition > 32 ? html.classList.add('scrolled') : html.classList.remove('scrolled');
    });

    // Adds custom price copy for Rebuy recommended widget
    const addMemberPriceToRebuyWidget = () => {
      const pdpRebuyWidget = document.getElementById('rebuy-widget-56359');
      const memberDiscount = (100 - window.Scoutside.memberDiscount) / 100;

      if (pdpRebuyWidget) {
        const rebuyPrices = document.querySelectorAll('.rebuy-money');
        const rebuyPriceArr = [...rebuyPrices];
        rebuyPriceArr.map((a) => {
          return a.insertAdjacentHTML(
            'afterend',
            `<span class="rebuy-member-price"><span>Member Price</span>$${+(
              +a.textContent.replace('Price $', '') * memberDiscount
            ).toFixed(2)}</span>`
          );
        });
      }
    };

    document.addEventListener('recommendLoad', addMemberPriceToRebuyWidget);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-bundle-filter"] && !Shopify.designMode) return;
  try {
    
  let selectedFilter = null
  onFilterClick = a => {
    const scrollToElement = document.getElementById(a)
    if (scrollToElement) {
      scrollToElement.scrollIntoView(true)
    }
    if (selectedFilter) {
      const previousFilter = document.getElementById(`${selectedFilter}-filter`)
      previousFilter.classList.remove('border-t-2')
      previousFilter.classList.remove('bg-sage-100')
    }

    const newFilter = document.getElementById(`${a}-filter`)
    if (newFilter) {
      newFilter.classList.add('border-t-2')
      newFilter.classList.add('bg-sage-100')
    }

    selectedFilter = a
  }

  const bundleFilterObserver = new MutationObserver(mutations_list => {
    mutations_list.forEach(mutation => {
      mutation.addedNodes.forEach(added_node => {
        if (added_node.classList && added_node.classList.contains('rb-review-order')) {
          document.querySelector('.rb-frequency-title').innerText = 'Subscribe frequency'
          const frequencyLabel = document.querySelector('.rb-frequency-label span')
          frequencyLabel.innerText = 'pick frequency (pause/cancel anytime)'
          frequencyLabel.classList.add('text-xs')
          const frequencySelect = document.querySelector('.rb-frequency-select-wrapper')
          const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
          svg.setAttribute('class', 'w-6 h-auto my-auto mx-1 text-evergreen')
          svg.setAttribute('aria-hidden', 'true')
          svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg')
          svg.setAttribute('fill', 'none')
          svg.setAttribute('viewBox', '0 0 14 8')
          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
          path.setAttribute('stroke', 'currentColor')
          path.setAttribute('stroke-linecap', 'round')
          path.setAttribute('stroke-linejoin', 'round')
          path.setAttribute('stroke-width', '2')
          path.setAttribute('d', 'm1 1 5.326 5.7a.909.909 0 0 0 1.348 0L13 1')

          svg.appendChild(path)

          frequencySelect.insertBefore(svg, frequencySelect.firstChild)
          frequencySelect.classList.add('flex')
        } else if (added_node?.classList?.contains('rb-multi-step')) {
          const stepTitles = document.querySelectorAll('.rb-step-name')
          stepTitles[1].innerText = 'Choose meats'
          const options = document.querySelectorAll('.rb-option-details')
          options.forEach(option => {
            const copy = option.innerText.split(', ')
            option.innerText = copy[0]
            document.createEle
            const child = document.createElement('div')
            child.innerText = copy[1]
            child.classList.add(
              'order-4',
              'text-left',
              'text-xl',
              'text-sage',
              'pt-2',
              'flex-grow',
              'absolute',
              'bottom-8'
            )
            option.parentElement.appendChild(child)
          })
          const banner = document.createElement('div')
          banner.id = 'banner'
          banner.classList.add(
            'bg-white',
            'border',
            'border-sage',
            'w-full',
            'flex',
            'flex-row',
            'justify-between',
            'mt-8',
            'm-auto',
            'order-3',
            'h-80',
            'max-w-[450px]',
            'md:max-w-[942px]',
            'm-auto',
            'rounded'
          )
          const bannerLeft = document.createElement('div')
          const bannerRight = document.createElement('div')
          const bannerCenter = document.createElement('div')
          bannerLeft.classList.add('banner-left', 'flex-0', 'md:flex-[36]')
          bannerCenter.classList.add('banner-center', 'flex-1')
          bannerRight.classList.add('banner-right', 'flex-0', 'md:flex-[36]')

          bannerCenter.innerHTML = `<div class="banner-center">
            <div class="title">Pick Your Frequency</div>
            <div class="subtitle">We'll send you a box every</div>
            <ul class="list">
              <li class="list-item">2 weeks</li>
              <li class="list-item">4 weeks</li>
              <li class="list-item">8 weeks</li>
            </ul>
            <div class="note">You can pause or cancel anytime.</div>
          </div>`

          banner.appendChild(bannerLeft)
          banner.appendChild(bannerCenter)
          banner.appendChild(bannerRight)

          const stepBody = document.querySelector('.rb-step-body')
          if (false && stepBody) {
            stepBody.classList?.add('flex', 'flex-col')
            stepBody.appendChild(banner)
          }
        } else if (added_node.role == 'navigation') {
          added_node.style.background = 'white'
        } else if (added_node.role == 'status') {
          const banner = document.getElementById('banner')
          if (banner) {
            banner?.classList?.add('hidden')
          }

          if (added_node && added_node.innerText && added_node.innerText.includes('Choose 7')) {
            const filters = document.getElementById('bundle-filters')
            if (!window.location.pathname.includes('all-ground-bundle')) filters.style.display = 'block'
          }
          document.querySelectorAll('.rb-item').forEach(item => {
            item.classList.add('bg-white', 'border', 'rounded-md', 'pb-4')
          })
          document.querySelectorAll('.rb-step-index--complete').forEach(item => {
            item.style.color = 'white'
          })
          const item = document.querySelector('.rb-sticky-content')
          item.style.background = 'white'
        }
      })
      mutation.removedNodes.forEach(removed_node => {
        if (removed_node.role == 'status') {
          const filters = document.getElementById('bundle-filters')
          filters.style.display = 'none'
          bundleFilterObserver.disconnect()
        }
      })
    })
  })
  bundleFilterObserver.observe(document.querySelector('#shopify-block-recharge-bundles-widget-block'), {
    subtree: true,
    childList: true
  })

  const confirmationFilterObserver = new MutationObserver(mutations_list => {
    mutations_list.forEach(mutation => {
      mutation.addedNodes.forEach(added_node => {
        if (added_node && added_node.innerText && added_node.innerText.includes('Add to cart')) {
          const groups = document.querySelectorAll('.rb-box-contents-title')

          groups.forEach(group => {
            group.remove()
          })
        }
      })
    })
  })
  confirmationFilterObserver.observe(document.querySelector('#shopify-block-recharge-bundles-widget-block'), {
    subtree: true,
    childList: true
  })

  // const step1Observer = new MutationObserver((mutations) => {
  //   mutations.forEach((mutation) => {
  //     mutation.addedNodes.forEach((node) => {
  //       if (node) {
  //         const stepNode = node.querySelector('.rb-step-wrapper[data-step]');
  //         if (stepNode) {
  //           }
  //       }
  //     });
  //   })
  // });

  // step1Observer.observe(document.querySelector('#bundling-app'), {childList: true,subtree: true});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-collection"] && !Shopify.designMode) return;
  try {
    
  onSizeClick = (id, size) => {
    alert(`${id} - ${size}`)
    const otherSize = size === '10' ? '24' : '10'
    const selectedSize = document.getElementById(`${id}-back-${size}`)
    const otherSizeButton = document.getElementById(`${id}-back-${otherSize}`)

    selectedSize.classList.remove('bg-white', 'border-sage', 'text-sage')
    selectedSize.classList.add('bg-sage')

    otherSizeButton.classList.remove('bg-sage')
    otherSizeButton.classList.add('bg-white', 'border-sage', 'border', 'text-sage')
  }

  onQuickView = id => {
    const card = document.getElementById(id)
    const cardBack = document.getElementById(`${id}-back`)
    card.style.display = 'none'
    cardBack.style.display = 'block'
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-select-a-plan"]) return;
  try {
    
  let planSelected = null
  let sizeSelected = null
  let progress = 1

  onRadioSelect = id => {
    const radioInput = document.getElementById(id)
    const frequencyLabel = document.getElementById('frequency')
    const frequency = id.split('-')[1]

    frequencyLabel.innerText = `every ${frequency} weeks.`
  }

  incrementProgress = () => {
    const currentStep = document.getElementById(`step-${progress}`)
    if (progress >= 6) {
      progress = 1
      return
    }
    const nextStep = document.getElementById(`step-${progress + 1}`)
    currentStep.style.display = 'none'
    nextStep.style.display = 'flex'

    progress = progress + 1
    document.getElementById('progress').dataset.progress = progress
  }

  onLearnMoreClick = () => {
    const bundleOptions = document.querySelectorAll('[id$=-bundle-options]')
    const cancelIcons = document.querySelectorAll('[id$=-cancel]')
    const optionsVisible = Array.from(bundleOptions).some(a => a.style.display === 'flex')

    cancelIcons.forEach(c => (c.style.transform = optionsVisible ? '' : 'rotate(45deg)'))

    bundleOptions.forEach(b => (b.style.display = optionsVisible ? 'none' : 'flex'))
  }

  onSizeClick = size => {
    const sizeClicked = document.getElementById(size)
    const nextButton = document.getElementById('next-button')

    if (nextButton) {
      nextButton.disabled = false
    }

    if (size === sizeSelected) {
      return
    }

    const oldSize = document.getElementById(sizeSelected)
    if (oldSize) {
      oldSize.classList.remove('bg-sage')
    }

    sizeClicked.classList.add('bg-sage')
    sizeSelected = size
  }

  decrementProgress = () => {
    if (progress <= 1) {
      progress = 1
      return
    }
    progress = progress - 1
    document.getElementById('progress').dataset.progress = progress
  }

  } catch(e) { console.error(e); }
})();
})();
